import React from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "antd";
import { UpcomingAndOngoingData } from "../Data/TripDetailData";
import { TRIP_STATUS } from "../Data/TripConstants";
import CustomRoundedImage from "../../../Core/Components/CustomRoundedImage";
import TripInformation from "../TripDetails/TripInformation";
import StopDetails from "../TripDetails/StopDetails";
import { useTenantPermission } from "../../../Core/hooks/usePermission";
import { TENANT_PERMISSIONS } from "../../Login/constants";

const TripKpiAndInformation = ({ tripChecklist = [] }) => {
  const { currentTrip, tripDetailsKPI } = useSelector((state) => state.trips);

  const hasTenantTrikePermission = useTenantPermission([
    TENANT_PERMISSIONS.TRIKE_MODULE_ACCESS,
  ]);

  return (
    <div className="flex flex-col p-6 bg-background h-[calc(100vh-128px)] overflow-y-scroll">
      <Row gutter={8}>
        {UpcomingAndOngoingData(tripDetailsKPI, currentTrip)
          ?.slice(0, 3)
          ?.map((kpi) => (
            <Col span={8} key={kpi.id}>
              <div
                className={`p-4 rounded-md ${
                  currentTrip.statusId === TRIP_STATUS.UPCOMING
                    ? "bg-light-grey"
                    : "bg-kpi-background"
                }
        `}
              >
                <div className="flex items-center gap-x-2.5">
                  <CustomRoundedImage
                    background="bg-kpi-icon"
                    image={kpi.icon}
                  />
                  <p className="text-xs font-normal capitalize font-aileron text-trip-kpi-title">
                    {kpi.title}
                  </p>
                </div>
                <p className="ml-12 text-2xl font-semibold text-trip-kpi-value font-poppins">
                  {kpi.value}
                  {kpi.unit && (
                    <span className="text-base ml-0.5">{kpi.unit}</span>
                  )}
                </p>
              </div>
            </Col>
          ))}
      </Row>

      {!hasTenantTrikePermission && (
        <Row gutter={8} className="mt-2">
          {UpcomingAndOngoingData(tripDetailsKPI, currentTrip)
            ?.slice(6)
            ?.map((kpi) => (
              <Col span={8} key={kpi.id}>
                <div
                  className={`p-4 rounded-md ${
                    currentTrip.statusId === TRIP_STATUS.UPCOMING
                      ? "bg-light-grey"
                      : "bg-kpi-background"
                  }
        `}
                >
                  <div className="flex items-center gap-x-2.5">
                    <CustomRoundedImage
                      background="bg-kpi-icon"
                      image={kpi.icon}
                    />
                    <p className="text-xs font-normal capitalize font-aileron text-trip-kpi-title">
                      {kpi.title}
                    </p>
                  </div>
                  <p className="ml-12 text-2xl font-semibold text-trip-kpi-value font-poppins">
                    {kpi.value}
                    {kpi.unit && (
                      <span className="text-base ml-0.5">{kpi.unit}</span>
                    )}
                  </p>
                </div>
              </Col>
            ))}
        </Row>
      )}

      <Row gutter={8} className="mt-2">
        {UpcomingAndOngoingData(tripDetailsKPI, currentTrip)
          ?.slice(3, 6)
          ?.map((kpi) => (
            <Col span={8} key={kpi.id}>
              <div
                className={`p-4 rounded-md ${
                  currentTrip.statusId === TRIP_STATUS.UPCOMING
                    ? "bg-light-grey"
                    : "bg-kpi-background"
                }
        `}
              >
                <div className="flex items-center gap-x-2.5">
                  <CustomRoundedImage
                    background="bg-kpi-icon"
                    image={kpi.icon}
                  />
                  <p className="text-xs font-normal capitalize font-aileron text-trip-kpi-title">
                    {kpi.title}
                  </p>
                </div>
                <p className="ml-12 text-2xl font-semibold text-trip-kpi-value font-poppins">
                  {kpi.value}
                  {kpi.unit && (
                    <span className="text-base ml-0.5">{kpi.unit}</span>
                  )}
                </p>
              </div>
            </Col>
          ))}
      </Row>

      {hasTenantTrikePermission && (
        <Row className="mt-6">
          <Col span={24}>
            <TripInformation tripChecklist={tripChecklist} />
          </Col>
        </Row>
      )}

      <Row className="mt-6">
        <Col span={24}>
          <StopDetails />
        </Col>
      </Row>
    </div>
  );
};

export default TripKpiAndInformation;
